import { FaGithub, FaLinkedinIn } from "react-icons/fa";
import { FiPhone } from "react-icons/fi";

// Single source of truth for identity and contact details used across sections.
export const NAME = "NIYOBYOSE Paulin";

export const GITHUB_URL = "https://github.com/Paulin-NIYOBYOSE";
export const GITHUB_HANDLE = "Paulin-NIYOBYOSE";
export const LINKEDIN_URL = "https://www.linkedin.com/in/niyobyose-paulin-41669838b/";
export const LINKEDIN_NAME = "NIYOBYOSE PAULIN";

export const CONTACT_EMAIL = "niyobyosepaulin20@gmail.com";
export const CONTACT_PHONE = "+250796358871";
export const PHONE_DISPLAY = "+250 796 358 871";

export const LOCATION = "Kigali, Rwanda";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=Kigali,+Rwanda";

export const RESUME_URL = "/Paulin_Niyobyose_CV.pdf";
export const RESUME_FILENAME = "Paulin_Niyobyose_CV.pdf";

// The only social / contact profiles shown across the site.
export const socialLinks = [
    { name: "GitHub", icon: FaGithub, href: GITHUB_URL, external: true },
    { name: "LinkedIn", icon: FaLinkedinIn, href: LINKEDIN_URL, external: true },
    { name: "Phone", icon: FiPhone, href: `tel:${CONTACT_PHONE}`, display: PHONE_DISPLAY, external: false },
];
